import React from 'react';

import useJobMenu from '../../hooks/useJobMenu';
import constants from '../../constants';
import Dashboard, { DashboardEvent } from '../common/Dashboard';

function Home() {
  useJobMenu('Home', constants.operations.isf);

  function onDashboardClick(e: DashboardEvent) {
    window.console.log(e);
  }

  return (
    <Dashboard onClick={onDashboardClick} />
  );
}

export default Home;
